// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Users Area
export class AreaIntegrations {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /**
     * @returns Array of AuthenticationTokens
     */
    async getAuthenticationTokens() {
        return this.dataCore.getAuthenticationTokens();
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Create/Update
    /** Creates a Personal Access Token.
     * @param name - Name of the token.
     * @param scope - Scope of the token.
     */
    async createAuthenticationToken(name, scope) {
        return this.dataCore.createAuthenticationToken(name, scope);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Delete
    /**
     * @returns Array of AuthenticationTokens
     */
    async deleteAuthenticationToken(id) {
        return this.dataCore.deleteAuthenticationToken(id);
    }
}
